import { cn } from "@/lib/utils";

/**
 * OSF brand mark. `full` renders the complete logo image (light-bg artwork in
 * light mode, white-on-transparent artwork in dark mode); `wordmark` is the
 * compact sidebar lockup; `icon` is just the speed-lined "O".
 */
export function Logo({
  variant = "wordmark",
  className,
}: {
  variant?: "icon" | "wordmark" | "full";
  className?: string;
}) {
  if (variant === "icon") {
    return <img src="/logos/osf-icon.png" alt="OSF" className={cn("h-9 w-auto", className)} />;
  }

  if (variant === "full") {
    return (
      <span className={className}>
        <img src="/logos/logo-light.png" alt="OSF — Order & Sales Flow" className="h-full w-auto dark:hidden" />
        <img src="/logos/logo-dark.png" alt="OSF — Order & Sales Flow" className="hidden h-full w-auto dark:block" />
      </span>
    );
  }

  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <img src="/logos/osf-icon.png" alt="OSF" className="h-9 w-auto" />
      <div className="leading-tight">
        <p className="font-display text-base font-bold">OSF</p>
        <p className="text-[10px] font-medium uppercase tracking-wide text-muted-foreground">Order &amp; Sales Flow</p>
      </div>
    </div>
  );
}
